import React, { useState, useEffect, useCallback } from "react";
import { inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import { sendMetriks } from "Services/sendMetriks";
import { addAddressData, addABData } from "Utils";
import userInfo from "Services/UserInfo";
import OneClickForm from "componentsUI/Form/OneClickForm";
import { PaddingBottom } from "ComponentsUI/Spacings";

const Type = {
    "/:regionUrl?": "main",
    "/:regionUrl?/reviews/:page([0-9]+)?": "reviews",
    "/:regionUrl?/rates/:page([0-9]+)?": "TC",
    "/:regionUrl?/address/:districtName-id:districtId/:streetName-id:streetId/:house_url-id:house_id/:page([0-9]+)?": "TC",
    "/:regionUrl?/orders/tohome": "tohome",
    "/:regionUrl?/exclusive": "exclusive",
    "/:regionUrl?/rating": "rating",
    "/:regionUrl?/providers/:page([0-9]+)?": "catalog",
    "/:regionUrl?/rating/:providerName/otzyv-:reviewId": "review_one",
};

const OneClick = props => {
    const [seen, setSeen] = useState(false);
    const [send, setSend] = useState(false);
    const [errorCounter, setErrorCounter] = useState(0);
    const [error, setError] = useState(false);
    const [phone, setPhone] = useState("");

    const {
        ApplicationModel: {
            siteConfig,
            sendingStore,
            currentRegion,
            windowSizeModel: { windowSizes },
            text,
            popupModel,
        },
        match: { path },
    } = props;

    const page = Type[path];

    const scrollToElement = useCallback(() => {
        let elementTarget = document.getElementById("OneClickForm");
        if (elementTarget) {
            if (
                !seen &&
                window.scrollY >
                    elementTarget.offsetTop - elementTarget.offsetHeight
            ) {
                window.removeEventListener("scroll", scrollToElement);
                sendMetriks("SCROLL_TO_1CLICK");
                setSeen(() => true);
            }
        }
    }, [seen]);

    useEffect(() => {
        if (!seen) window.addEventListener("scroll", scrollToElement);
        return () => {
            window.removeEventListener("scroll", scrollToElement);
        };
    }, [scrollToElement, seen]);

    if (!page) return null;

    const dataForm = siteConfig?.settings?.form_orders_one_click
        ? siteConfig.settings.form_orders_one_click
        : null;
    if (!dataForm) return null;

    const form = dataForm[page];

    if (!form) return null;

    const goToRates = async () => {
        let regionId = currentRegion?.id || null;
        let data = {
            phone_connection: phone,
            region_id: regionId,
            lead_form_type: userInfo("one_click", page),
        };

        if (props.providerId) {
            data.provider_id = props.providerId;
        }
        data = addAddressData(data, props.ApplicationModel);

        data = addABData(data);

        let infoUser = {
            name_popup: "OneClick",
        };
        popupModel.setInfoUser(infoUser);

        let errorSending = await sendingStore.onCallback(data);
        if (!errorSending) {
            setSend(true);
        }
    };

    const deleteError = () => {
        setErrorCounter(0);
        setError(false);
    };

    const onChangePhone = e => {
        let {
            ApplicationModel: { sendingStore },
        } = props;

        deleteError();
        sendingStore.setPhone(e.target.value);
        setPhone(e.target.value);
    };

    const onClickButton = () => {
        if (phone.length != 11) {
            setError(true);
            setErrorCounter(errorCounter + 1);
            return;
        }
        sendMetriks("LEAD_ALL");
        sendMetriks("SEND_1CLICK");
        goToRates();
    };

    const onPressEnter = () => {
        if (!send) onClickButton();
    };

    return (
            <PaddingBottom>
                <OneClickForm
                    form={form}
                    onChangePhone={onChangePhone}
                    phone={phone}
                    onPressEnter={onPressEnter}
                    errorCounter={errorCounter}
                    error={error}
                    send={send}
                    text={text}
                    windowSizes={windowSizes}
                    ABtest={page === "TC"}
                ></OneClickForm>
            </PaddingBottom>
    );
};
export default withRouter(inject("ApplicationModel")(OneClick));
